import { render, staticRenderFns } from "./EndOfNavBar.vue?vue&type=template&id=6c648977&scoped=true&"
import script from "./EndOfNavBar.vue?vue&type=script&lang=js&"
export * from "./EndOfNavBar.vue?vue&type=script&lang=js&"
import style0 from "./EndOfNavBar.vue?vue&type=style&index=0&id=6c648977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../huang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c648977",
  null
  
)

export default component.exports